import { instance } from "utils/axios";

export const getJobApplicationPdfServices = async request => {
    instance.defaults.headers.post['JJKAuthTF'] = request.key;
    return await instance.post('api/wizard/GetJobApplicationPdf', request.payload);
};